import { CONTAINER_LABELS, ITEM_LABELS } from '../constants';
export function inContainer(item) {
    switch (item) {
        case ITEM_LABELS.CHANNEL:
            return CONTAINER_LABELS.CHANNELS;
        case ITEM_LABELS.SERVER:
            return CONTAINER_LABELS.SERVERS;
        case ITEM_LABELS.MESSAGE:
            return CONTAINER_LABELS.MESSAGES;
        case ITEM_LABELS.SCHEMA:
            return CONTAINER_LABELS.SCHEMAS;
        default:
            return '';
    }
}
//# sourceMappingURL=inContainer.js.map